import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderImage } from '@/types/image';
import { imageService } from '@/services/image.service';

interface SliderState {
  images: SliderImage[];
  loading: boolean;
  error: string | null;
}

const initialState: SliderState = {
  images: [],
  loading: false,
  error: null,
};

export const fetchSliderImages = createAsyncThunk(
  'slider/fetchImages',
  async () => {
    const response = await imageService.getSliderImages();
    return response.result;
  }
);

const sliderSlice = createSlice({
  name: 'slider',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSliderImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSliderImages.fulfilled, (state, action) => {
        state.loading = false;
        state.images = action.payload;
      })
      .addCase(fetchSliderImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch images';
      });
  },
});

export default sliderSlice.reducer;